import { createContext, useContext } from 'react';

import type { InstallCapability } from '@/features/storefront/pwa/installPrompt';

/** What the footer's install button needs from `InstallAppProvider`. */
export interface InstallApp {
  /** False once the shop is installed, or this is the installed app. */
  available: boolean;
  capability: InstallCapability;
  busy: boolean;
  storeName: string;
  /** Chrome's own dialog where there is one; the instructions everywhere else. */
  start: () => Promise<void>;
}

export const InstallAppContext = createContext<InstallApp | null>(null);

/** The shop's install offer, or `null` outside a shop that can be installed. */
export function useInstallApp(): InstallApp | null {
  return useContext(InstallAppContext);
}
